'use strict'

import firebase from 'firebase/app'
import 'firebase/messaging'

const config = require('AppConfig')

/**
 * プッシュ通知の制御クラス
 */
class FBMessaging {
    /**
     * 初期化処理
     * @returns {void}
     */
    initializeMessaging = () => {
        if ('serviceWorker' in navigator && 'PushManager' in window) {
            const messaging = firebase.messaging()
            messaging.usePublicVapidKey(config.publicVapidKey)

            navigator.serviceWorker
                .register(
                    '/smbiz/member/' + DEVICE + '/js/potaufeu-messaging-sw.js'
                )

                .then(registration => {
                    messaging.useServiceWorker(registration)

                    //通知の許可をユーザに確認
                    return messaging.requestPermission()
                })
                .then(() => {
                    return messaging.getToken()
                })
                .then(token => {
                    this.saveMessagingDeviceToken(token)
                })
                .catch(err => {
                    //通知不許可などの場合にここでエラー発生
                    console.log(err)
                })

            messaging.onMessage(payload => {
                var notificationTitle = payload.notification.title // タイトル

                var notificationOptions = {
                    body: payload.notification.body,
                    data: payload.notification.click_action,
                    icon: payload.notification.image // アイコン
                }

                if (!('Notification' in window)) {
                    // ブラウザが通知機能に対応しているかを判定
                } else {
                    // 通知許可されていたら通知する
                    var notification = new Notification(
                        notificationTitle,
                        notificationOptions
                    )
                }
            })

            messaging.onTokenRefresh(() => {
                messaging
                    .getToken()
                    .then(refreshedToken => {
                        //console.log('Token refreshed.')
                        this.saveMessagingDeviceToken(refreshedToken)
                    })
                    .catch(err => {
                        console.error(
                            'Unable to retrieve refreshed token ',
                            err
                        )
                    })
            })
        }
    }

    /**
     * メッセージトークンをfirestoreにセット
     * @returns {void}
     */
    saveMessagingDeviceToken = () => {
        firebase
            .messaging()
            .getToken()
            .then(currentToken => {
                if (currentToken) {
                    //console.log('Got FCM device token:', currentToken)
                    let unsubscribe = firebase
                        .auth()
                        .onAuthStateChanged(user => {
                            unsubscribe()
                            if (user) {
                                let t = firebase.firestore.Timestamp.now()
                                let db = firebase.firestore()

                                db.collection('fcmTokens')
                                    .doc(currentToken)
                                    .set({
                                        createdAt: t,
                                        updatedAt: t,
                                        uid: user.uid
                                    })
                            }
                        })
                }
            })
            .catch(function(error) {
                console.error('Unable to get messaging token.', error)
            })
    }
}

const fbmessaging = new FBMessaging()
export default fbmessaging
